const SQE_LABS_RESTRICTED_PATHS = new Set([
  "/reimbursementrequest",
  "/createreimbursementrequest",
  "/approvereimbursements",
  "/bulkreimbursement",
  "/reimbursement-history",
  "/downloadreimbursement",
  "/enrollmentrequests",
  "/workstream",
  "/csatrating",
  "/configuration",
  "/tracking",
  "/event",
  "/approve-event",
  "/travel-req",
  "/approve-travel-req",
  "/travel-req-finance",
  "/user-role-report",
  "/asset-report",
  "/growthactivities",
  "/teamgrowth",
  "/growthinsights",
  "/givefeedback",
  "/selfcheck",
  "/myfeedback",
  "/admindashboard",
  "/emailsetuprequest",
  "/emailapproval",
  "/approveemailsetup",
  "/email-deletion",
  "/approve-email-deletion",
  "/welacomeaboardemailer",
  "/utilizationreport",
]);

const SQE_LABS_RESTRICTED_MENUS = new Set([
  "travel management",
  "analytics & insights",
  "growth & initatives",
  "growth & initiatives",
  "performance lens",
  "adhoc email setup",
]);

const SQE_EMPLOYEE_TYPES = new Set(["SQE", "SQELABS"]);

type NavigationLabelOverride = {
  employeeTypes: ReadonlySet<string>;
  matches: (label: string) => boolean;
  replacement: string;
};

const NAVIGATION_LABEL_OVERRIDES: readonly NavigationLabelOverride[] = [
  {
    employeeTypes: SQE_EMPLOYEE_TYPES,
    matches: (label) => /caelius'?\s+policies/i.test(label),
    replacement: "SQE Policies",
  },
  {
    employeeTypes: SQE_EMPLOYEE_TYPES,
    matches: (label) => label.trim().toLowerCase() === "caelius connect",
    replacement: "SQE Connect",
  },
];

const RENAMED_NAVIGATION_LABELS: Record<string, string> = {
  "employee management": "Team Management",
  "my reimbursements": "Expense Claims",
  "appraisal management": "Appraisal Hub",
};

function normalizeEmployeeType(value: unknown): string {
  return String(value ?? "")
    .replace(/[^a-zA-Z0-9]/g, "")
    .toUpperCase();
}

export function formatNavigationLabel(
  label: string | undefined,
  employeeTypes: unknown | readonly unknown[],
): string | undefined {
  if (!label) return label;

  const normalizedLabel = label.trim().toLowerCase();
  const canonicalLabel = /caelius'?\s+policies/i.test(label.trim())
    ? "Caelius Policies"
    : RENAMED_NAVIGATION_LABELS[normalizedLabel] ?? label;
  const normalizedTypes = (Array.isArray(employeeTypes) ? employeeTypes : [employeeTypes])
    .map(normalizeEmployeeType);
  const override = NAVIGATION_LABEL_OVERRIDES.find(
    (item) =>
      normalizedTypes.some((type) => item.employeeTypes.has(type)) &&
      item.matches(canonicalLabel),
  );

  return override?.replacement ?? canonicalLabel;
}

export function isSQELabsEmployeeType(value: unknown): boolean {
  return normalizeEmployeeType(value) === "SQELABS";
}

export function isSQEEmployeeType(value: unknown): boolean {
  return SQE_EMPLOYEE_TYPES.has(normalizeEmployeeType(value));
}

export function isRestrictedForSQELabsMenu(name: string): boolean {
  const normalized = name.trim().toLowerCase();
  return normalized.includes("reimbursement") || SQE_LABS_RESTRICTED_MENUS.has(normalized);
}

export function isRestrictedForSQELabsPath(path: string | undefined): boolean {
  return path
    ? SQE_LABS_RESTRICTED_PATHS.has(path.trim().toLowerCase())
    : false;
}
